module.exports = __webpack_public_path__ + "img/back-to-top-button.fb6f1b0.svg";